var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pub-panel-full",class:[{'avoid-footer': _vm.isAvoidFooter}]},[(_vm.isShowHeader)?_c('pub-header',{attrs:{"headTitle":_vm.headTitle,"isCustomMethod":true},on:{"customMethod":_vm.customMethod}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3ec753","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/control/panel-full.vue
// module id = qQFj
// module chunks = 0